import React, {useState, useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';

import moment from 'moment';

import {size} from 'lodash';

import {currentResource, labels} from '../../../../../util/utils';
import {minDate} from '../../../../../util/uiconstants';

import {getClientRequest} from '../../../../../actions/ClientPortalMetrics';
import ExportWithTopDetails from '../../../../Common/ExportToExcel/ExportWithTopDetails';
import {FILE_NAME, FILE_NAME_DATE_FORMAT, clientRequestHeaders} from './utils/constants';
import selectAllEntitiesIds from '../../../../../reducers/Metrics/selector/selectAllEntitiesIds';

const GenerateExcel = () => {
	const dispatch = useDispatch();
	const dashboardContext = useSelector((store) => store.dashboardContext);	
    const project = useSelector((store) => store.project);
    const clientRequest = useSelector((store) => store.clientRequest);
    const dateFormat = useSelector((store) => store.userPreferences.dateFormat);
	const entities = selectAllEntitiesIds();  
	const [dataReceived, setDataReceived] = useState(true);
	const exportToExcelLabels = currentResource.exportToExcelLabels;
	
	//Need this to specificaly handle the delay in redux getting updated after api call (api call is being made on click of export) and getting updated data in exported file.
	useEffect(() => {
		setDataReceived(true);
	},[clientRequest]);

	const getExportDetails = () => {
		return {
            projectName: project.name,
            fileName: `${project.name}${FILE_NAME}${moment().utc().format(FILE_NAME_DATE_FORMAT)}`,
			title: labels.canvasClientPortalEy,
			columns: getColumnsToExport(),
			data: getDataToExport(),
			worksheetName: labels.canvasClientPortalEy
		};
	};

	const getColumnsToExport = () => {
		let columns = [];
		columns.push({header: exportToExcelLabels.engagementName, key: clientRequestHeaders.engagementName});
		columns.push({header: exportToExcelLabels.engagementId, key: clientRequestHeaders.engId});
		columns.push({header: exportToExcelLabels.requestItemNumber, key: clientRequestHeaders.reqItemNumber});
		columns.push({header: exportToExcelLabels.requestTitle, key: clientRequestHeaders.reqTitle});
		columns.push({header: exportToExcelLabels.priority, key: clientRequestHeaders.priority});
		columns.push({header: exportToExcelLabels.status, key: clientRequestHeaders.status});
		columns.push({header: exportToExcelLabels.receivedDate, key: clientRequestHeaders.receivedDate});
		columns.push({header: exportToExcelLabels.dueDate, key: clientRequestHeaders.dueDate});
		columns.push({header: exportToExcelLabels.overdue, key: clientRequestHeaders.overdue});
		columns.push({header: exportToExcelLabels.eyContact, key: clientRequestHeaders.eyContact});
		columns.push({header: exportToExcelLabels.assignedTo, key: clientRequestHeaders.assignedTo});
		return columns;
	};

	const getDataToExport = () => {
		let data = [];

		dashboardContext.orgChart.forEach(() => {
			if (dashboardContext && dashboardContext.engagements && size(dashboardContext.engagements) > 0) {
				dashboardContext.engagements.forEach((eng) => {
					let clientRequestData = clientRequest?.filter((x) => x.engId === eng);

					if (clientRequestData?.length > 0) {
						clientRequestData.forEach(element => {
							data.push({
								engagementName: element?.engagementName,
								engId: element?.engId,
								reqItemNumber: element?.referenceNo,
								reqTitle: element?.requestTitle,
								priority: exportToExcelLabels.priorityTypeLabels.find((x) => x.id === element?.priorityTypeId)?.label,
								receivedDate: element?.receivedDate !== minDate ? moment(element?.receivedDate).utc().format(dateFormat) : '',
								status: exportToExcelLabels.statusLabels.find((x) => x.id === element?.status)?.label,
								dueDate: moment(element?.dueDate).utc().format(dateFormat),
								overdue: element?.isOverdue ? exportToExcelLabels.yes : exportToExcelLabels.no,
								eyContact: element?.eyContact,
								assignedTo: element?.assignedTo
							});
						});
					}
				});
			}
		});

		return data;
	};
	const getClientRequestData = () => {
		dispatch(getClientRequest(project.projectId, entities));
		setDataReceived(false);
	}
	const prop = {
		getDataToExport: getExportDetails,
		buttonTitle: exportToExcelLabels.exportButtonTitle,
        labels: exportToExcelLabels,
		requestData: getClientRequestData,
		dataReceived: dataReceived
	};

	return project.projectId !== undefined && <ExportWithTopDetails {...prop} />;
};

export default GenerateExcel;
